.stockSectionContainer {
    border-radius: 12px;
    border: 1px solid var(--static-divider-standard);
}

.table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.tableCell {
    font-size: var(--fs-small);
    font-weight: 500;
    line-height: 20px;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-left: 1.5rem;
    text-align: left;
}

.verticalContainer {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.smallTitleText {
    font-size: var(--fs-small);
    font-weight: 500;
    line-height: 16px;
}

.totalInput {
    /*border-radius: 8px;*/
    /*border: 1px solid var(--static-divider-standard);*/
    background: var(--static-divider-standard);
    /*padding: 0.25rem 0.75rem;*/
    font-size: var(--fs-small);
}

.lastTableCell {
    width: 5rem;
}

.tableCell {
    padding: 0.625rem 1.5rem;
}

.costCategoriesTableCell {
    padding: 0.625rem 1.5rem;
}

.closeButtonContainer {
    display: flex;
    justify-content: center;
}

.closeButton {
    cursor: pointer;
    background-color: transparent;
    border: none;
    /*padding: 0.5rem;*/
    /*z-index: 2;*/
    color: var(--static-text-standard);
}

.smallText {
    font-size: var(--fs-small);
}

.rowDivider {
    /* Creates a 1px divider between rows with the same style */
    border-bottom: 1px solid var(--static-divider-standard);
}


.costCategoriesButtons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem
}

.datePicker {
    width: 100%;
    background-color: var(--static-background-standard) !important;
    font-size: 14px !important;
}

